// src/client/game/core/levels/LevelFactory.ts
import { Level, type LevelId, type LevelConfig } from "./Level";

const TARGET = 1000;

const LEVELS: Record<number, LevelConfig> = {
  1: { id: 1, label: "Hatchling", targetScore: TARGET, blurb: "Learn to survive. Red food only." },
  2: { id: 2, label: "Greed Mode", targetScore: TARGET, blurb: "Gold joins the mix. Speed and length can kill you." },
  3: { id: 3, label: "First Blood", targetScore: TARGET, blurb: "Laser charge appears. Practice firing safely from the tail." },
  4: { id: 4, label: "Cold Snap", targetScore: TARGET, blurb: "Icy food enters. First competitor snake spawns." },
  5: { id: 5, label: "The Arena", targetScore: TARGET, blurb: "More competition. Triple-beam charge starts to appear." },
  6: { id: 6, label: "Star Rush", targetScore: TARGET, blurb: "Stars reward risky routes. Clip management matters." },
  7: { id: 7, label: "Frostbite", targetScore: TARGET, blurb: "Control the chaos with ice. The board gets tighter." },
  8: { id: 8, label: "Crossfire", targetScore: TARGET, blurb: "Laser enemies begin. Watch your angles." },
  9: { id: 9, label: "Thunder Run", targetScore: TARGET, blurb: "Lightning charge appears. Hunters get smarter." },
  10:{ id:10, label: "Boss Royale", targetScore: TARGET, blurb: "Everything at once. Win the final 1000-point brawl." },
};

export const MIN_LEVEL: LevelId = 1;
export const MAX_LEVEL: LevelId = 10;

export function clampLevel(id: number): LevelId {
  if (id < MIN_LEVEL) return MIN_LEVEL;
  if (id > MAX_LEVEL) return MAX_LEVEL;
  return id as LevelId;
}

export function createLevel(id: LevelId): Level {
  const cfg = LEVELS[id];
  if (!cfg) throw new Error(`Unknown level id: ${id}`);
  return new Level(cfg);
}

export function listLevels(): Level[] {
  const out: Level[] = [];
  for (let i = MIN_LEVEL; i <= MAX_LEVEL; i++) out.push(createLevel(i));
  return out;
}
